import React, { Component, Fragment } from "react";

import { inject, observer } from "mobx-react";
import { Link, withRouter } from "react-router-dom";
// import NumberFormat from "react-number-format";
// import moment from "moment";
import { ProfileType, BookingType, BookingStatusType, RosterDividendType, LineupStatusType} from "../../types/enum";
import "./BookingDetails.css";
import { Grid, Typography, Button, Checkbox, Snackbar, IconButton, Tooltip, MenuItem, Menu, CircularProgress, Chip, Input, Select } from "@material-ui/core";
import ResponsiveTable from "../table/ResponsiveTable";
import BookingStatusBadge from "./BookingStatusBadge";
import FacebookPostDialog from "../facebookPostDialog/FacebookPostDialog";
import moment from "moment";

import ClearIcon from "@material-ui/icons/Clear";
import PrintModal from "./PrintModal.js/PrintModal";
import PrintIcon from "@material-ui/icons/Print";
import facebook from "../../img/facebook-box.svg";

import currencyHelper from '../../helper/currency';
import FacebookSharePostDialog from "../facebookSharePostDialog/FacebookSharePostDialog";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import CheckCircle from "@material-ui/icons/CheckCircle";
import DirectionsIcon from "@material-ui/icons/Directions";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import EditIcon from "@material-ui/icons/Edit";
import CancelIcon from "@material-ui/icons/Cancel";
import GetAppIcon from "@material-ui/icons/GetApp";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import bookingCalculationHelper from "../../helper/bookingCalculationHelper"
import BulkEditModal from "./BulkEditModal"
import BulkCancelModal from "./BulkCancelModal"
import ConfirmationModal from "../modal/ConfirmationModal"
import agent from "../../agent"

const CANCELLABLE_STATUSES = [
    BookingStatusType.New.ordinal,
    BookingStatusType.Hold.ordinal,
    BookingStatusType.Accepted.ordinal,
    BookingStatusType.LineupSet.ordinal,
    BookingStatusType.SetlistSet.ordinal,
    BookingStatusType.Ready.ordinal,
    BookingStatusType.Resent.ordinal,
    BookingStatusType.SentToAct.ordinal,
    BookingStatusType.PlayerNotified.ordinal,
    BookingStatusType.AllPlayerConfirmed.ordinal,
    BookingStatusType.ClientNotified.ordinal,
    BookingStatusType.PlayerInvitedAndClientNotified.ordinal,
    BookingStatusType.PlayerConfirmedAndClientNotified.ordinal
];
import "react-select/dist/react-select.css";
import "./BookingAllFilters.css";


const FACEBOOK_ENABLED = process.env.REACT_APP_FACEBOOK_ENABLED === "true";

const BOOKING_STATUS = [
    "New",
    "Declined",
    "Negotiate",
    "Accepted",
    "LineupSet",
    "SetlistSet",
    "Ready",
    "Completed",
    "Paid",
    "Cancelled",
    "Resent",
    "Draft",
    "Incomplete",
    "Cancelled By Act",
    "Cancelled By Act",
    "SentToAct",
    "PlayerNotified",
    "PlayerDeclined",
    "AllPlayerConfirmed",
    "ClientNotified",
    "PlayerInvitedAndClientNotified",
    "PlayerConfirmedAndClientNotified"
];

const STATUS_DISPLAY_LABELS = {
    "New": "Sent",
    "Declined": "Declined",
    "Negotiate": "Negotiate",
    "Accepted": "Accepted",
    "LineupSet": "LineupSet",
    "SetlistSet": "SetlistSet",
    "Ready": "Confirmed",
    "Completed": "Completed",
    "Paid": "Paid",
    "Cancelled": "Cancelled",
    "Resent": "Resent",
    "Draft": "Draft",
    "Incomplete": "Incomplete",
    "Cancelled By Act": "Cancelled By Act",
    "SentToAct": "Sent To Act",
    "PlayerNotified": "Player(s) Notified",
    "PlayerDeclined": "Player(s) Declined",
    "AllPlayerConfirmed": "All Player(s) Confirmed",
    "ClientNotified": "Client Notified",
    "PlayerInvitedAndClientNotified": "Player(s) and Client Notified",
    "PlayerConfirmedAndClientNotified": "Player(s) Confirmed and Client Notified"
};

@inject("profileStore", "bookingRequestStore", "templateStore", "facebookStore", "reportStore")
@withRouter
@observer
class BookingAll extends Component {
    state = {
        columns: [],
        acknowledgeSnackbarState: false,
        booking: undefined,
        selectedBookings: [],
        showPrintOption: false,
        allGigs: [],
        sharedBookings: [],
        isLoading: false,
        page: 1,
        actionAnchor: [],
        bulkEditModalOpen: false,
        bulkCancelModalOpen: false,
        cancelModalState: false,
        cancelBooking: null,
        isExporting: false,
        statusFilter: []
    };

    rows = [];

    setActionAnchor = (element, bookingId) => {
        var tempAnchor = [];
        tempAnchor[bookingId] = element;
        this.setState({ ...this.state, actionAnchor: tempAnchor });
    };

    unsetActionAchnor = bookingId => {
        this.setState({ ...this.state, actionAnchor: [] });
    };

    componentDidMount() {
        const {
            currentProfile
        } = this.props.profileStore;
        const { upcomings, requests, cancelled, completed, drafts,allGigsBooking } = this.props.bookingRequestStore;
        const { social } = this.props;
        
        if (this.props.profileType === "agent") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date/Time", width: "12%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "venue", label: "Venue", width: "14%" },
                    { key: "actName", label: "Act Name", width: "14%" },
                    { key: "status", label: "Status", width: "10%", style: { whiteSpace: 'normal', wordWrap: 'break-word' } },
                    { key: "gigFee", label: <Tooltip title="Venue/Client Fee"><span>V/C Fee</span></Tooltip>, sortable: true, width: "9%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "agentFee", label: <Tooltip title="Agent Fee"><span>Agent Fee</span></Tooltip>, sortable: true, width: "9%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "actFee", label: <Tooltip title="Performance Fee"><span>Perf. Fee</span></Tooltip>, sortable: true, width: "9%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "superFee", label: <Tooltip title="Superannuation Fee"><span>Super Fee</span></Tooltip>, sortable: true, width: "8%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "feePaidToAct", label: <Tooltip title="Invoice Amount"><span>Inv. Amt</span></Tooltip>, sortable: true, width: "8%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "action", label: "Actions", width: "7%" }
                ]
            });
        } else if (this.props.profileType === "musician") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date/Time", width: "12%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "venue", label: "Venue", width: "14%" },
                    { key: "actName", label: "Act Name", width: "14%" },
                    { key: "status", label: "Status", width: "10%", style: { whiteSpace: 'normal', wordWrap: 'break-word' } },
                    !social && { key: "gigFee", label: <Tooltip title="Venue/Client Fee"><span>V/C Fee</span></Tooltip>, sortable: true, width: "9%", isNumber:true, align: 'left', style: { flexDirection: 'row' } },
                    !social && { key: "agentCommissionAmount", label: "Agent Fee", sortable: true, isNumber: true, width: "9%", align: 'left', style: { flexDirection: 'row' } },
                    !social && { key: "myFee", label: <Tooltip title="Performance Fee"><span>Perf. Fee</span></Tooltip>, width: "9%", isNumber:true, align: 'left', style: { flexDirection: 'row' } },
                    !social && { key: "superFee", label: "Super Fee", sortable: true, width: "8%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    !social && { key: "feePaidToAct", label: <Tooltip title="Invoice Amount"><span>Inv. Amt</span></Tooltip>, sortable: true, width: "8%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "action", label: "Actions", width: "7%" }
                ]
            });
        } else if (this.props.profileType === "staff") {
            if(currentProfile && currentProfile.type === ProfileType.Staff.ordinal && !currentProfile.viewOnly){
                this.setState({
                    ...this.state,
                    columns: [
                        { key: "date", label: "Date", width: "15%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                        { key: "status", label: "Status", width: "15%" },
                        { key: "actName", label: "Act Name", width: "15%" },
                        { key: "venue", label: "Venue", width: "15%" },
                        !social && { key: "gigFee", label: "Gig Fee", sortable: true, width: "10%", isNumber:true, align: 'left', style: { flexDirection: 'row' } }, 
                        !social && { key: "agentCommissionAmount", label: "Agent Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        !social && { key: "actFee", label: "Performance Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        
                        
                        // { key: "interested", label: "Interested", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        // { key: "going", label: "Going", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        // { key: "acknowledge", label: "Acknowledged", width: "10%", style: { textAlign: "center" } },
                        // { key: "socialPosts", label: "Social Posts",  width: "15%", align: 'center', style: {whiteSpace: 'nowrap'}},
                        { key: "bookingCreator", label: "Booking Creator", width: "10%" },
                        { key: "action", label: "", width: "5%" }
                    ]
                });
            }else{
                this.setState({
                    ...this.state,
                    columns: [
                        { key: "date", label: "Date", width: "15%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                        { key: "status", label: "Status", width: "15%" },
                        { key: "actName", label: "Act Name", width: "15%" },
                        { key: "venue", label: "Venue", width: "15%" },
                        !social && { key: "gigFee", label: "Gig Fee", sortable: true, width: "10%", isNumber:true, align: 'left', style: { flexDirection: 'row' } }, 
                        !social &&   { key: "agentCommissionAmount", label: "Agent Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        // { key: "interested", label: "Interested", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        // { key: "going", label: "Going", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        // { key: "acknowledge", label: "Acknowledged", width: "10%", style: { textAlign: "center" } },
                        { key: "bookingCreator", label: "Booking Creator", width: "10%" },
                        { key: "action", label: "", width: "5%" }
                    ]
                });
            }
        }else if (this.props.profileType === "PrivateHire") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date", width: "20%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "status", label: "Status", width: "20%" },
                    { key: "actName", label: "Act Name", width: "20%" },
                    { key: "venue", label: "Venue", width: "25%" },
                    !social && { key: "gigFee", label: "Gig Fee", sortable: true, width: "10%", isNumber:true, align: 'left', style: { flexDirection: 'row' } }, 
                    { key: "bookingCreator", label: "Booking Creator", width: "10%" },
                    { key: "action", label: "", width: "5%" }
                ]
            });
        }
       
       
    }

    loadGigs = (page) => {
        const {
            currentProfile
        } = this.props.profileStore;
        if(this.props.profileType === "PrivateHire"){
            Promise.all([
                this.props.bookingRequestStore.loadAllGigs(currentProfile?.id)
            ]).then(() => {            
                // allGigs = allGigsBooking
    
                this.props.bookingRequestStore.hideLoadingState();            
    
                // this.setState({ isLoading: false });
                window.scrollTo(0, 0);
            })
            .finally(() => {
                this.showLoadingLocal(false)
            });
        }else{
            Promise.all([
                this.props.bookingRequestStore.loadAllGigs(currentProfile?.id,page)
            ]).then((result) => {            
                // allGigs = allGigsBooking
               
                this.props.bookingRequestStore.hideLoadingState();            
    
                // this.setState({ isLoading: false });
                // window.scrollTo(0, 0);
            })
            .finally(() => {
                this.showLoadingLocal(false)
                // this.props.bookingRequestStore.setAllPage(page)
            });
        }
    }

    
    showLoadingLocal = (value) => {
        let currentState = { ...this.state };
        currentState.isLoading = value;
        this.setState(currentState);
    }

    openAcknowledgeSnackbar = booking => {
        this.setState({
            ...this.state,
            acknowledgeSnackbarState: true,
            booking: booking
        });
    };

    closeAcknowledgeSnackbar = () => {
        this.setState({
            ...this.state,
            acknowledgeSnackbarState: false,
            booking: undefined
        });
    };

    handleShowMore = e => {
        var page = parseInt(this.props.bookingRequestStore.allPage) + 1;
        this.showLoadingLocal(true)
        this.loadGigs(page)
    };
    updatedSharedBookingState = () => {
        const { booking } = this.props.facebookStore;
        const { sharedBookings } = this.state;
        let postedIds = sharedBookings;
        if (booking) {
            postedIds.push(booking.id);
        }
        this.setState({
            ...this.state,
            sharedBookings: postedIds,
        })
    }

    handleAcknowledgeBooking = booking => {
        let message = `Catch ${booking.actName} playing here on ${moment(new Date(booking.dateStart)).format("DD-MM-YYYY")} from ${moment(
            booking.timeStart,
            "HH:mm:ss"
        ).format("hh:mm A")} to ${moment(booking.timeEnd, "HH:mm:ss").format("hh:mm A")}. `;
        if (booking.ticketUrl !== "") {
            message = message + `Tickets on sale ${booking.ticketUrl}.`;
        }
        this.props.facebookStore.setPostMessage(message);
        this.props.facebookStore.setBooking(booking);
        if (booking.venue.facebookPageId) {
            this.props.facebookStore.openFacebookPostDialog(booking.venue);
        } else {
            this.props.bookingRequestStore.venueStaffAcknowledgeGigs(booking.id).then(response => {
                this.openAcknowledgeSnackbar(response);
            });
        }
    };

    handleSharePost = async (booking, profile) => {
        const { currentProfile } = this.props.profileStore;
        let formattedVenueName = booking.venueName ? "#" + booking.venueName?.replace(/ /g, "") : booking.venue ? "#" + booking.venue?.profileName?.replace(/ /g, "") : "";
        let formattedActName = booking.actName ? "#" + booking.actName.replace(/ /g, "") : "";
        let formattedActName2 = booking.actName ? booking.actName : booking.act ? booking.act?.actName : ""
        let bookTableUrl = booking.venue && booking.venue.bookTableUrl ? booking.venue.bookTableUrl  : ""
        let message = `Hi Folks, Catch ${formattedActName2} playing here on ${moment(new Date(booking.dateStart)).format("DD-MM-YYYY")}  from ${moment(
            booking.timeStart,
            "HH:mm:ss" 
        ).format("hh:mm A")} to  ${moment(booking.timeEnd, "HH:mm:ss").format("hh:mm A")}.  Come and enjoy some great live entertainment - get in early and book a table! \n \n ${bookTableUrl} \n \n ${formattedActName} ${formattedVenueName} #livegigs #livegigs #livemusic #liveentertainment #hotgiggity`
        if(currentProfile.type === ProfileType.Musician.ordinal){
            message = `Hi Folks!  I am playing a gig at ${formattedVenueName} on the ${moment(new Date(booking.dateStart)).format("DD-MM-YYYY")}  from ${moment(
                booking.timeStart,
                "HH:mm:ss" 
            ).format("hh:mm A")} to  ${moment(booking.timeEnd, "HH:mm:ss").format("hh:mm A")}.  See you there!! \n \n #livegigs #livemusic #liveentertainment #hotgiggity `
        }
        
        if (booking.ticketUrl !== "") {
            message = message + `Tickets on sale ${booking.ticketUrl}.`;
        }
        if(booking.venue){
            booking.venue.backgroundImages = await this.props.profileStore.getBackgroundImage(booking.venue.id);
        }
        if(booking.act){
            booking.act.backgroundImages = await this.props.profileStore.getBackgroundImage(booking.act.id);
        }
        this.props.facebookStore.setPostMessage(message);
        this.props.facebookStore.setBooking(booking);
        if (profile.type === ProfileType.Musician.ordinal) {
            if (booking?.act?.facebookPageId) {
                this.props.facebookStore.openFacebookSharePostDialog(booking.act);
            } else {
                this.props.facebookStore.openFacebookSharePostDialog(currentProfile);
            }
        } else if (profile.type === ProfileType.Staff.ordinal) {
            this.props.facebookStore.openFacebookSharePostDialog(booking.venue);
              // this.props.bookingRequestStore.venueStaffAcknowledgeGigs(booking.id).then(response => {
            //     this.openAcknowledgeSnackbar(response);
        } else if (profile.type === ProfileType.Agent.ordinal) {
            this.props.facebookStore.openFacebookSharePostDialog(booking.agent);
        }
    };

    handleUndoAcknowledge = () => {
        if (this.state.booking) {
            this.props.bookingRequestStore.venueStaffUnacknowledgeGigs(this.state.booking.id).then(response => {
                this.closeAcknowledgeSnackbar();
                this.props.templateStore.openSnackbar(`Changes to ${response.title} has been reverted.`);
            });
        }
    };

    getBookingStatus = booking => {
        const { currentProfile } = this.props.profileStore
        if (booking.isCompletedGig) {
            return BOOKING_STATUS[BookingStatusType.Completed.ordinal]
        }
        if (booking.status === BookingStatusType.New.ordinal && booking.saveAsDraft) {
            return "Draft";
        }
        if (booking.createdById !== currentProfile?.id && (booking.status === BookingStatusType.AllPlayerConfirmed.ordinal || booking.status === BookingStatusType.PlayerConfirmedAndClientNotified.ordinal)) {
            return "Accepted"
        }
    
        return BOOKING_STATUS[booking.status];
        
    };

    exportToCSV = () => {
        const { selectedBookings } = this.state;
        const { allGigs } = this.props.bookingRequestStore;
        const { venueId } = this.props.reportStore;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        
        this.setState({ isExporting: true });
        
        try {
            const selectedIds = selectedBookings.map(row => row.id);
            const originalBookings = allGigs.filter(booking => selectedIds.includes(booking.id));
            
            const data = originalBookings.map(booking => {
                const collectedFee = bookingCalculationHelper.calculatedBookingFee(booking, currentProfile);
                const venueName = booking.venueName || booking.venue?.profileName || "";
                const venueAddress = booking.venue?.street1 
                    ? `${booking.venue.street1}${booking.venue.city ? ', ' + booking.venue.city : ''}${booking.venue.state ? ', ' + booking.venue.state : ''}`
                    : "";
                
                return {
                    date: moment(booking.dateStart).format("DD/MM/YYYY"),
                    timeStart: moment(booking.timeStart, "HH:mm:ss").format("hh:mm A"),
                    timeEnd: moment(booking.timeEnd, "HH:mm:ss").format("hh:mm A"),
                    venueName: venueName,
                    venueAddress: venueAddress,
                    actName: booking.actName || booking.act?.actName || "",
                    status: this.getBookingStatus(booking),
                    venueClientFee: parseFloat(collectedFee.gigFee || 0).toFixed(2),
                    agentFee: parseFloat(collectedFee.agentFeeNumber || 0).toFixed(2),
                    performanceFee: parseFloat(collectedFee.performanceFee || booking.actFee || 0).toFixed(2),
                    invoiceAmount: parseFloat(collectedFee.feePaidToActNumber || 0).toFixed(2)
                };
            });

            const headers = ["Date", "Time Start", "Time End", "Venue Name", "Venue Address", "Act Name", "Status", "Venue/Client Fee", "Agent Fee", "Performance Fee", "Invoice Amount"];
            
            const csvContent = [
                headers.join(","),
                ...data.map(row => [
                    `"${row.date}"`,
                    `"${row.timeStart}"`,
                    `"${row.timeEnd}"`,
                    `"${row.venueName.replace(/"/g, '""')}"`,
                    `"${row.venueAddress.replace(/"/g, '""')}"`,
                    `"${row.actName.replace(/"/g, '""')}"`,
                    `"${row.status}"`,
                    row.venueClientFee,
                    row.agentFee,
                    row.performanceFee,
                    row.invoiceAmount
                ].join(","))
            ].join("\n");

            const agencyName = currentProfile?.profileName || "Agency";
            
            let venueLabel = "All Venues";
            if (venueId && originalBookings.length > 0) {
                const firstBooking = originalBookings[0];
                venueLabel = firstBooking.venueName || firstBooking.venue?.profileName || "All Venues";
            }
            
            const dates = originalBookings.map(b => moment(b.dateStart));
            let dateRange = moment().format("YYYY-MM-DD");
            if (dates.length > 0) {
                const minDate = moment.min(dates).format("DD-MM-YYYY");
                const maxDate = moment.max(dates).format("DD-MM-YYYY");
                dateRange = minDate === maxDate ? minDate : `${minDate} to ${maxDate}`;
            }
            
            const safeAgencyName = agencyName.replace(/[^a-zA-Z0-9 ]/g, "").trim();
            const safeVenueLabel = venueLabel.replace(/[^a-zA-Z0-9 ]/g, "").trim();
            const filename = `${safeAgencyName} - ${safeVenueLabel} - All Gigs - ${dateRange}.csv`;

            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error exporting CSV:", error);
            this.props.templateStore.openSnackbar("Error exporting CSV. Please try again.");
        } finally {
            this.setState({ isExporting: false });
        }
    };

    isRelatedCreator = (booking) => {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        if (!currentProfile) return false;
        return currentProfile.id === booking.createdById || (booking.relatedCreatorId && booking.relatedCreatorId.includes(String(currentProfile.id)));
    };

    renderTableCustomActions = () => {
        const { selectedBookings, isExporting } = this.state;
        const isDisabled = !selectedBookings || selectedBookings.length === 0;
        const hasNonCreator = !isDisabled && selectedBookings.some(row => !row.isRelatedCreator);
        const hasCancelled = !isDisabled && selectedBookings.some(row => 
            row.statusOrdinal === BookingStatusType.Cancelled.ordinal || 
            row.statusOrdinal === BookingStatusType.CancelledByAct.ordinal || 
            row.statusOrdinal === BookingStatusType.CancelledByActHistory.ordinal
        );
        const hasUncancellable = !isDisabled && selectedBookings.some(row => 
            row.statusOrdinal === BookingStatusType.Cancelled.ordinal || 
            row.statusOrdinal === BookingStatusType.Completed.ordinal
        );
        const isBulkDisabled = isDisabled || hasNonCreator;
        const isBulkEditDisabled = isBulkDisabled || hasCancelled || selectedBookings.length > 40;
        const isCancelDisabled = isBulkDisabled || hasUncancellable || selectedBookings.length > 40;
        return (
            <Fragment>
                <Button 
                    onClick={this.openBulkEditModal} 
                    disabled={isBulkEditDisabled} 
                    style={{ color: !isBulkEditDisabled ? "#fff" : undefined }}
                >
                    <EditIcon style={{ color: !isBulkEditDisabled ? "#fff" : undefined, marginRight: 4 }} />
                    Bulk Edit
                </Button>
                <Button 
                    onClick={this.openBulkCancelModal} 
                    disabled={isCancelDisabled} 
                    style={{ color: !isCancelDisabled ? "#fff" : undefined }}
                >
                    <CancelIcon style={{ color: !isCancelDisabled ? "#fff" : undefined, marginRight: 4 }} />
                    Bulk Cancel
                </Button>
                {selectedBookings.length > 40 && (
                    <span style={{ color: "#e65100", fontSize: 13, fontWeight: 500, marginLeft: 8, alignSelf: "center" }}>
                        &#9888; Bulk actions are limited to 40 bookings. Please deselect some.
                    </span>
                )}
                <Button onClick={this.openPrintOptionModal} disabled={isDisabled} style={{ color: !isDisabled ? "#fff" : undefined }}>
                    <PrintIcon style={{ color: !isDisabled ? "#fff" : undefined }} />
                    Print
                </Button>
                <Button 
                    onClick={this.exportToCSV} 
                    disabled={isDisabled || isExporting} 
                    style={{ color: !isDisabled && !isExporting ? "#fff" : undefined, marginLeft: 8 }}
                >
                    {isExporting ? (
                        <CircularProgress size={20} style={{ color: "#fff", marginRight: 4 }} />
                    ) : (
                        <GetAppIcon style={{ color: !isDisabled ? "#fff" : undefined }} />
                    )}
                    {isExporting ? "Exporting..." : "Download CSV"}
                </Button>
            </Fragment>
        )
    };

    renderFooterRow = () => {
        let { allGigs } = this.props.bookingRequestStore;
        const { profileType } = this.props;
        const { venueId } = this.props.reportStore;
        const { statusFilter } = this.state;
        const currentProfile = this.props.profileStore.getCurrentProfile();

        if (venueId) {
            allGigs = allGigs.filter(x => x.venueId === venueId)
        }

        if (statusFilter && statusFilter.length > 0) {
            allGigs = allGigs.filter(booking => {
                const status = this.getBookingStatus(booking);
                return statusFilter.includes(status);
            });
        }
        var totalFee = 0;
        var totalActFee = 0;
        var totalAgentFee = 0;
        var totalMyFee = 0

        allGigs.forEach(booking => {
            let linuep = booking.lineups && booking.lineups?.find(x => x.profileId === currentProfile?.id);
            var musicianFee = parseFloat(booking.gigFee) - totalFee
            const isEntertainerBookings = currentProfile?.type === ProfileType.Musician.ordinal && booking.createdById === currentProfile?.id && !booking.act?.actName;

            let adminFeeRoster = 0
            let totalRosterFeeAdmin = 0
            booking?.act?.actRoster?.forEach(actRoster => {
                let feeCount = 0
                if(actRoster.dividendType === RosterDividendType.Percentage.ordinal){
                    feeCount = actRoster.dividendAmount /100 * booking.actFee;
                }else {
                    feeCount = actRoster.dividendAmount;
                }
                totalRosterFeeAdmin = totalRosterFeeAdmin + feeCount
            })
            adminFeeRoster = booking.actFee - totalRosterFeeAdmin
            if(currentProfile?.type === ProfileType.Musician.ordinal && !booking?.lineups?.length){
                let actRoster = booking?.act?.actRoster?.filter(x => x.rosters.some(t => t.profileId === currentProfile?.id));
               
                if(actRoster?.length){
                    if(actRoster[0].dividendType === RosterDividendType.Percentage.ordinal){
                        musicianFee = actRoster[0].dividendAmount /100 * booking.actFee;
                    }else {
                        musicianFee = actRoster[0].dividendAmount;
                    }
                    if(this.props.profileType === 'musician'){
                        if(booking?.act?.actAdminId === currentProfile?.id){
                            musicianFee = parseFloat(musicianFee) + parseFloat(adminFeeRoster)
                        }
                    }
                }else{
                    musicianFee = booking.actFee
                    booking?.act?.actRoster?.forEach(item => {
                        var rosterFee = 0
                        if(item.dividendType === RosterDividendType.Percentage.ordinal){
                            rosterFee = item.dividendAmount /100 * booking.actFee;
                        }else {
                            rosterFee = item.dividendAmount;
                        }
                        musicianFee = musicianFee - rosterFee
                    });
                }
            }
             
            var totalRosterFee = 0

            booking?.lineups?.forEach(lineUp => {
                totalRosterFee = parseFloat(totalRosterFee) + parseFloat(lineUp.fee) 
            })
            var adminFee = booking.actFee - totalRosterFee
            var calculateFee = linuep?.fee ?  linuep?.fee : 0
            if(this.props.profileType === 'musician'){
                if(booking?.act?.actAdminId === currentProfile?.id){
                    calculateFee = parseFloat(calculateFee) + parseFloat(adminFee)
                }
            }
            
            let myFee = linuep?.fee ? calculateFee: isEntertainerBookings ? booking.gigFee : (booking.isAdmin && !linuep) ? musicianFee : booking.actFee;
          
            let actOwner = booking?.act?.userId === currentProfile?.userId;            

            totalFee += (booking.viewOnly) ? 0 : (profileType === "agent" || profileType === "staff") && booking.isApproved ? Number(booking.gigFee) + Number(booking.extraGigFee) : Number(booking.gigFee);
            totalActFee += this.props.profileType === "musician" && !actOwner ? 0 : Number(booking.actFee);
            totalAgentFee += Number(booking.agentCommissionAmount);
            totalMyFee += Number(myFee);
        });

        return {
            gigFee: ( (currentProfile && currentProfile.type === ProfileType.Staff.ordinal && !currentProfile.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalFee, 2)}`,
            actFee: ( (currentProfile && currentProfile.type === ProfileType.Staff.ordinal && !currentProfile.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalActFee, 2)}`,
            agentCommissionAmount: ((currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalAgentFee, 2)}`, 
            agentFee: ((currentProfile && currentProfile.type === ProfileType.Staff.ordinal && !currentProfile.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalAgentFee, 2)}`, 
            myFee: ((currentProfile && currentProfile.type === ProfileType.Staff.ordinal && !currentProfile.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalMyFee, 2)}`,
            style: {
                textAlign: 'left'
            }
        }
    }

    getCheckedRows = rows => {
        this.setState({
            ...this.state,
            selectedBookings: rows
        })
    };

    openPrintOptionModal = () => {
        this.setState({
            ...this.state,
            showPrintOption: true
        })
    }

    closePrintOptionModal = () => {
        this.setState({
            ...this.state,
            showPrintOption: false
        })
    }

    openBulkEditModal = () => this.setState({ bulkEditModalOpen: true });

    closeBulkEditModal = () => this.setState({ bulkEditModalOpen: false });

    openBulkCancelModal = () => this.setState({ bulkCancelModalOpen: true });

    closeBulkCancelModal = () => this.setState({ bulkCancelModalOpen: false });

    handleBulkCancelComplete = () => {
        this.setState({ selectedBookings: [] });
    };

    handleOpenCancelBookingModal = (booking) => {
        this.setState({ cancelModalState: true, cancelBooking: booking, actionAnchor: [] });
    };

    handleCloseCancelBookingModal = () => {
        this.setState({ cancelModalState: false, cancelBooking: null });
    };

    handleCancelBooking = () => {
        const { currentProfile } = this.props.profileStore;
        const { cancelBooking } = this.state;
        this.props.bookingRequestStore.saveStatusBooking(currentProfile?.id, BookingStatusType.Cancelled.ordinal, cancelBooking).then(() => {
            this.props.templateStore.openSnackbar("Booking cancelled!");
            this.handleCloseCancelBookingModal();
            this.props.bookingRequestStore.updateBookingStatusLocally(cancelBooking.id, BookingStatusType.Cancelled.ordinal);
        }).catch(() => {
            this.props.templateStore.openSnackbar("Failed to cancel booking. Please try again.");
            this.handleCloseCancelBookingModal();
        });
    };

    handleBulkEditSubmit = async (selectedBookings, updates) => {
        const { currentProfile } = this.props.profileStore;
        
        try {
            const result = await this.props.bookingRequestStore.bulkUpdateBookings(selectedBookings, updates, true, currentProfile?.id);
            
            this.setState({ selectedBookings: [] });
            
            return result;
        } catch (error) {
            console.error("Bulk edit error:", error);
            throw error;
        }
    };

    handleStatusFilterChange = (event) => this.setState({ statusFilter: event.target.value });

    handleRemoveStatusFilter = (statusToRemove) => {
        this.setState(prevState => ({
            statusFilter: prevState.statusFilter.filter(s => s !== statusToRemove)
        }));
    };

    handleClearStatusFilter = () => this.setState({ statusFilter: [] });

    isConnectedToFb = (booking) => {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        let status;

        if (this.props.profileType === 'musician') {
            status = currentProfile && currentProfile.facebookPageId || booking?.act?.facebookPageId ? true : false;
        } else if (this.props.profileType === 'staff') {
            status = booking.venue.facebookPageId ? true : false;
        } else if (this.props.profileType === 'agent') {
            status = currentProfile && currentProfile.facebookPageId ? true : false
        }

        return status
    };

    renderMobileGigCard = (row, index, onCheckboxChange) => {
        return (
            <div key={index} className="mobile-gig-card" style={row.style}>
                <div className="mobile-gig-card-select">
                    <Checkbox
                        checked={!!row.checked}
                        onChange={onCheckboxChange}
                        disabled={row.disableCheckbox}
                        color="primary"
                        style={{ padding: '4px' }}
                    />
                    <span className="mobile-gig-card-select-label">Select</span>
                </div>
                <div className="mobile-gig-card-header">
                    {row.date?.newFormat}
                    <div className="mobile-gig-card-venue">
                        {row.venue}
                    </div>
                </div>
                <div className="mobile-gig-card-fees">
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Venue/Client Fee</span>
                        <span className="mobile-gig-fee-value">{row.gigFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Agent Fee</span>
                        <span className="mobile-gig-fee-value">{row.agentCommissionAmount}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Performance Fee</span>
                        <span className="mobile-gig-fee-value">{row.myFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Invoice Amount</span>
                        <span className="mobile-gig-fee-value">{row.feePaidToAct}</span>
                    </div>
                </div>
                <div className="mobile-gig-card-footer">
                    <div className="mobile-gig-card-act">
                        <div className="mobile-gig-card-status">{row.status}</div>
                        {row.actName}
                    </div>
                    <div className="mobile-gig-card-actions">
                        {row.action}
                    </div>
                </div>
            </div>
        );
    }

    renderAgentMobileGigCard = (row, index, onCheckboxChange) => {
        return (
            <div key={index} className="mobile-gig-card" style={row.style}>
                <div className="mobile-gig-card-select">
                    <Checkbox
                        checked={!!row.checked}
                        onChange={onCheckboxChange}
                        disabled={row.disableCheckbox}
                        color="primary"
                        style={{ padding: '4px' }}
                    />
                    <span className="mobile-gig-card-select-label">Select</span>
                </div>
                <div className="mobile-gig-card-header">
                    {row.date?.newFormat}
                    <div className="mobile-gig-card-venue">
                        {row.venue}
                    </div>
                </div>
                <div className="mobile-gig-card-act" style={{ padding: '12px 16px', borderBottom: '1px solid #eee' }}>
                    <div className="mobile-gig-card-status">{row.status}</div>
                    {row.actName}
                </div>
                <div className="mobile-gig-card-fees">
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Venue/Client Fee</span>
                        <span className="mobile-gig-fee-value">{row.gigFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Agent Fee</span>
                        <span className="mobile-gig-fee-value">{row.agentFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Performance Fee</span>
                        <span className="mobile-gig-fee-value">{row.actFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Invoice Amount</span>
                        <span className="mobile-gig-fee-value">{row.feePaidToAct}</span>
                    </div>
                </div>
                <div className="mobile-gig-card-footer">
                    <div className="mobile-gig-card-actions">
                        {row.action}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let { allGigs, isLoading } = this.props.bookingRequestStore;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        const { profileType, social } = this.props;
        const { venueId } = this.props.reportStore;
        const { showPrintOption, selectedBookings, bulkEditModalOpen, bulkCancelModalOpen, statusFilter } = this.state;
        if (venueId) {
            allGigs = allGigs.filter(x => x.venueId === venueId);
            this.props.bookingRequestStore.setBookingsCount("allGigs", allGigs);
            
        }

        allGigs = _.uniqBy(allGigs, "id");
        allGigs = _.sortBy(allGigs, "dateStart");

        const availableStatuses = [...new Set(allGigs.map(booking => this.getBookingStatus(booking)))].sort();

        if (statusFilter && statusFilter.length > 0) {
            allGigs = allGigs.filter(booking => {
                const status = this.getBookingStatus(booking);
                return statusFilter.includes(status);
            });
        }

        return (
            <Fragment>
                <Grid container spacing={8}>
                    <Grid item xs={12} lg={12} style={{ marginBottom: 16 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 8 }}>
                            <Typography variant="headline" component="h3" style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}>
                                All Gigs
                                <Tooltip title={profileType === "musician" || profileType === "dj" || profileType === "production"
                                    ? "This is the list of all your gigs."
                                    : "This is the list of all gigs."}>
                                    <HelpOutlineIcon style={{ fontSize: 20, color: '#888', cursor: 'pointer' }} />
                                </Tooltip>
                            </Typography>
                            {availableStatuses.length > 0 && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                <Select
                                    multiple
                                    value={statusFilter}
                                    onChange={this.handleStatusFilterChange}
                                    displayEmpty
                                    input={<Input id="status-filter" disableUnderline />}
                                    style={{ 
                                        minWidth: 200, 
                                        border: '1px solid #ccc', 
                                        borderRadius: 4, 
                                        padding: '4px 8px',
                                        backgroundColor: '#fff'
                                    }}
                                    renderValue={(selected) => {
                                        if (selected.length === 0) {
                                            return <span style={{ color: '#999' }}>Filter by status...</span>;
                                        }
                                        return (
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                                {selected.map((value) => (
                                                    <Chip 
                                                        key={value} 
                                                        label={STATUS_DISPLAY_LABELS[value] || value} 
                                                        size="small"
                                                        onDelete={(e) => {
                                                            e.stopPropagation();
                                                            this.handleRemoveStatusFilter(value);
                                                        }}
                                                        onMouseDown={(e) => e.stopPropagation()}
                                                        style={{ 
                                                            backgroundColor: '#FF0C9C', 
                                                            color: '#ffffff',
                                                            height: 24
                                                        }}
                                                        deleteIcon={
                                                            <ClearIcon 
                                                                style={{ color: '#ffffff', fontSize: 16, width: 16, height: 16 }} 
                                                                onMouseDown={(e) => e.stopPropagation()}
                                                            />
                                                        }
                                                    />
                                                ))}
                                            </div>
                                        );
                                    }}
                                >
                                    {availableStatuses.map(status => (
                                        <MenuItem key={status} value={status}>
                                            <Checkbox checked={statusFilter.includes(status)} style={{ padding: '0 8px 0 0' }} color="primary" />
                                            {STATUS_DISPLAY_LABELS[status] || status}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {statusFilter.length > 0 && (
                                    <Tooltip title="Clear all filters">
                                        <IconButton 
                                            onClick={this.handleClearStatusFilter}
                                            style={{ padding: 4 }}
                                        >
                                            <CancelIcon style={{ fontSize: 20, color: '#888' }} />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </div>
                            )}
                        </div>
                    </Grid>
                    <Grid item xs={12} lg={12} className="booking-table-wrapper" ref={el => (this.componentRef = el)}>
                        <LoadingSpinner showed={!isLoading && this.state.isLoading} />
                        <ResponsiveTable
                            showToolbar={true}
                            customActions={
                                this.renderTableCustomActions()
                            }
                            selectable={true}
                            getCheckedRows={this.getCheckedRows}
                            sortable
                            mobileSecondaryField="venue"
                            columns={this.state.columns}
                            mobileCardRenderer={profileType === "musician" ? this.renderMobileGigCard : profileType === "agent" ? this.renderAgentMobileGigCard : undefined}
                            rows={allGigs.map(booking => {
                                var row = {};
                                let date = new Date(booking.dateStart);
                                // row.date = date.getDate()+" "+this.props.templateStore.getMonth(date.getMonth())+" "+date.getFullYear();
                                row.id = booking.id;
                                row.statusOrdinal = booking.status;
                                row.isRelatedCreator = this.isRelatedCreator(booking);
                                var formattedDate = moment(booking.dateStart).format("YYYY-MM-DD")
                                
                              
                                let time = booking.timeStart.length < 8 ? `0${booking.timeStart}` : booking.timeStart;
                                let endTime = booking.timeEnd.length < 8 ? `0${booking.timeEnd}` : booking.timeEnd;
                                var finalDate= moment(formattedDate + ' ' + time)
                                row.date = {newFormat: 
                                    (
                                        <div className="gig-date-box">
                                            <div className="day-name">{booking.dateStart.format("ddd")}</div>
                                            <div className="date-number">{booking.dateStart.format("DD")}</div>
                                            <div className="month">{booking.dateStart.format("MMM YYYY")}</div>
                                            <div className="time-range">{`${moment(time, 'HH:mm:ss').format('h:mm A')} - ${moment(endTime, 'HH:mm:ss').format('h:mm A')}`}</div>
                                        </div>
                                    ), value: finalDate};
                                row.venue = (
                                    <div>
                                        <span style={{fontWeight: 600}}>{booking.venue ? booking.venue.profileName : booking.venueName}</span>
                                        <br />
                                        <small style={{color: '#888'}}>{booking.venueAddress}</small>
                                    </div>
                                );
                                // row.address = booking.venueAddress;
                                row.bookingCreator = booking?.createdBy ? (booking?.createdBy?.firstName + " " +booking?.createdBy?.lastName) : ""
                                var collectedFee = bookingCalculationHelper.calculatedBookingFee(booking, currentProfile)
                                row.gigFee = booking.createdBy?.type === ProfileType.Agent.ordinal && (booking.agentOwner?.hideVenueFees && currentProfile?.type === ProfileType.Musician.ordinal) ? <i className={"icon-eye-blocked"} /> :
                                (booking.viewOnly)  || (currentProfile && currentProfile.type === ProfileType.Staff.ordinal && !currentProfile.allowInvoices)
                                    ? <i class="far fa-eye-slash"></i>
                                    : `${currentProfile?.currencySymbol + ((profileType === "agent" || profileType === "staff") && booking.isApproved
                                        ? currencyHelper.formatMoney(collectedFee.gigFee + booking.extraGigFee, 2) 
                                        : currencyHelper.formatMoney(collectedFee.gigFee, 2))}`;
                                row.agentFee = collectedFee.agentFee
                                const isEntertainerBookings = currentProfile?.type === ProfileType.Musician.ordinal && booking.createdById === currentProfile?.id && !booking.act?.actName;

                                row.actName = profileType === "musician" ? (
                                    <div>
                                        <div className="gig-act-name">
                                            <a target={"_blank"} href={`/profile/${isEntertainerBookings ? currentProfile?.id : booking?.act?.id}`}>
                                                {isEntertainerBookings ? `${currentProfile?.firstName} ${currentProfile?.lastName}` : booking?.act?.actName}
                                            </a>
                                        </div>
                                        {booking.act?.contactName && <div className="gig-act-contact">{booking.act?.contactName}</div>}
                                        {booking.act?.contactPhone && <div className="gig-act-contact">{booking.act?.contactPhone}</div>}
                                    </div>
                                ) : booking.status === BookingStatusType.Resent.ordinal &&
                                (profileType === "agent" || profileType === "staff" || profileType === "venue") ? (
                                    <div>
                                        {booking.bookingRequests?.map(bookingRequest => (
                                            <Fragment>
                                                <Link target={"_blank"} to={`/profile/${bookingRequest?.act?.id}`}>{bookingRequest.act ? bookingRequest?.act?.actName : ""}</Link>
                                                <br />
                                                <small>Contact: {bookingRequest?.act?.contactName}</small><br />
                                                <small>Phone: {booking?.act?.contactPhone ? booking?.act?.contactPhone  : "-"}</small>
                                            </Fragment>
                                        ))}
                                    </div>
                                ) : (
                                    <div>
                                        <a target={"_blank"} href={`/profile/${isEntertainerBookings ? currentProfile?.id : booking?.act?.id}`}>{isEntertainerBookings ? `${currentProfile?.firstName} ${currentProfile?.lastName}` : booking?.act?.actName}</a>
                                        <br />
                                        {booking.act && <small>Contact: {booking?.act?.contactName}</small>}<br />
                                        {booking.act && <small>Phone: {booking?.act?.contactPhone ? booking?.act?.contactPhone  : "-"}</small>}
                                    </div>
                                );
                            
                                  let actOwner = booking.act?.userId === currentProfile?.userId;
                                
                                row.actFee = booking.createdBy?.type === ProfileType.Agent.ordinal && (currentProfile?.type === ProfileType.Staff.ordinal && booking.agentOwner?.hideVenueAgencyFees) ? <i className={"icon-eye-blocked"} /> : this.props.profileType === "musician" && !actOwner ? "" : currentProfile?.currencySymbol + currencyHelper.formatMoney(booking.actFee, 2);
                       
                             
                               
                                row.myFee = this.props.profileType === 'musician' && currentProfile?.currencySymbol + currencyHelper.formatMoney(collectedFee.myFee, 2);
                                row.agentCommissionAmount = collectedFee.agentCommissionAmount
                                row.superFee = collectedFee.superFee
                                row.feePaidToAct = collectedFee.feePaidToAct
                                
                                row.agentName = booking.agentName;
                                row.time = booking.timeStart.substring(0, 5);

                                let fbPostedStatus = this.state.sharedBookings.includes(booking.id);
                                let fbButtonDisabled = !this.isConnectedToFb(booking) || !booking.sharePermission || booking?.type === BookingType.Adhoc.ordinal || isEntertainerBookings;
                                let fbButtonStyle = (this.isConnectedToFb(booking) && booking.sharePermission && booking?.type !== BookingType.Adhoc.ordinal && !isEntertainerBookings) ? "fb-share" : "fb-share-disabled";
                                let fbButtonText = (!fbButtonDisabled && booking?.isPostToFacebook) || fbPostedStatus ? "Posted" : "Post to Facebook";
                                let fbHoverText = this.isConnectedToFb(booking) ? "" : "Connect your Facebook page to post this gig to Facebook"
                                
                                const isUpcomings = booking?.status === BookingStatusType.Accepted.ordinal || booking?.status === BookingStatusType.Incomplete.ordinal;
                               

                                if(currentProfile && currentProfile.type === ProfileType.Staff.ordinal && !currentProfile.viewOnly){
                                    row.socialPosts = isUpcomings && !booking?.isCompletedGig && (
                                        <Tooltip title={fbHoverText} >
                                            <Button disabled={fbButtonDisabled} className={fbButtonStyle} onClick={() => this.handleSharePost(booking, currentProfile)}>
                                                <img src={facebook} alt="fb" className="logo-fb" />&nbsp;&nbsp;{fbButtonText}
                                            </Button>
                                        </Tooltip>
                                    )
                                }

                                row.purchaseOrder = booking?.purchaseOrderCode;

                                row.acknowledge = booking?.acknowledge ? (
                                    <Tooltip
                                        title={
                                            <span>
                                                Acknowledge By:{" "}
                                                {`${booking?.acknowledgeBy ? booking?.acknowledgeBy.firstName : ""} ${
                                                    booking?.acknowledgeBy ? booking?.acknowledgeBy.lastName : ""
                                                }`}
                                            </span>
                                        }
                                        placement="bottom"
                                    >
                                        <Checkbox checked={true} disableRipple={true} />
                                    </Tooltip>
                                ) : (
                                    <Checkbox
                                        checked={booking?.acknowledge}
                                        onChange={() => this.handleAcknowledgeBooking(booking)}
                                        disabled={booking.acknowledge || !booking.canAcknowledge}
                                    />
                                );
                                
                                row.isSendBookingDetails = booking.isSendBookingDetails ? <div style={{textAlign:"center", width:"100%"}}><CheckCircle style={{ texAlign:"center",color: "green"}} /></div>  : null;
                                
                                const handleGetDirections = () => {
                                    const address = encodeURIComponent(booking.venueAddress || '');
                                    window.open(`https://www.google.com/maps/dir/?api=1&destination=${address}`, '_blank');
                                };
                                
                                const handleViewDetails = () => {
                                    let redirectUrl =
                                        booking?.type === BookingType.Adhoc.ordinal
                                        ? `/privateBooking/${booking.id}/edit`
                                        : isEntertainerBookings
                                            ? `/booking/${booking.id}/edit`
                                            : currentProfile?.type === ProfileType.Musician.ordinal
                                                ? `/musician/booking/${booking.id}/details`
                                                : currentProfile?.type === ProfileType.Agent.ordinal
                                                    ? `/booking/${booking.id}/edit`
                                                    : currentProfile?.type === ProfileType.Staff.ordinal
                                                        ? `/booking/${booking.id}/edit`
                                                        : "";
                                    process.env.REACT_APP_DISABLE_BILLING_MOBILE !== "true" ? window.open(redirectUrl, '_blank'):                         
                                    this.props.history.push(redirectUrl, { from: 'fromMyGigs' });
                                };
                                
                                const canEditBooking = booking.type === BookingType.Adhoc.ordinal && booking.createdById === currentProfile?.id;
                                const handleEditBooking = () => {
                                    const redirectUrl = `/privateBooking/${booking.id}/edit`;
                                    this.props.history.push(redirectUrl, { from: 'fromMyGigs' });
                                };

                                row.action = profileType === "musician" ? (
                                    <div className="gig-actions-dropdown">
                                        <Button 
                                            className="gig-actions-dropdown-btn"
                                            onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}
                                        >
                                            Actions <ArrowDropDownIcon />
                                        </Button>
                                        <Menu
                                            open={this.state.actionAnchor[booking.id] != null}
                                            onClose={() => this.unsetActionAchnor(booking.id)}
                                            anchorEl={this.state.actionAnchor[booking.id]}
                                        >
                                            <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); handleViewDetails(); }}>
                                                <VisibilityIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                View Details
                                            </MenuItem>
                                            {canEditBooking && (
                                                <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); handleEditBooking(); }}>
                                                    <EditIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                    Edit Booking
                                                </MenuItem>
                                            )}
                                            <MenuItem 
                                                onClick={() => { this.unsetActionAchnor(booking.id); handleGetDirections(); }}
                                                disabled={!booking.venueAddress}
                                            >
                                                <DirectionsIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                Get Directions
                                            </MenuItem>
                                            {CANCELLABLE_STATUSES.includes(booking.status) && this.isRelatedCreator(booking) && (
                                                <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.handleOpenCancelBookingModal(booking); }}>
                                                    <CancelIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                    Cancel Booking
                                                </MenuItem>
                                            )}
                                        </Menu>
                                    </div>
                                ) : profileType === "agent" ? (
                                    <div className="gig-actions-dropdown">
                                        <Button 
                                            className="gig-actions-dropdown-btn"
                                            onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}
                                        >
                                            Actions <ArrowDropDownIcon />
                                        </Button>
                                        <Menu
                                            open={this.state.actionAnchor[booking.id] != null}
                                            onClose={() => this.unsetActionAchnor(booking.id)}
                                            anchorEl={this.state.actionAnchor[booking.id]}
                                        >
                                            <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); handleViewDetails(); }}>
                                                <EditIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                View / Edit
                                            </MenuItem>
                                            {booking.createdById === currentProfile?.id && (
                                                <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.props.history.push(`/booking/${booking.id}/sendBookingEmail`); }}>
                                                    <span style={{ marginRight: 10, color: '#888', fontSize: 18 }}>✉</span>
                                                    Send Booking Details via Email
                                                </MenuItem>
                                            )}
                                            {booking.createdById === currentProfile?.id && (
                                                <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.props.history.push(`/booking/printBookingDetails/${booking.id}`); }}>
                                                    <PrintIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                    Print Booking Details
                                                </MenuItem>
                                            )}
                                            {CANCELLABLE_STATUSES.includes(booking.status) && this.isRelatedCreator(booking) && (
                                                <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.handleOpenCancelBookingModal(booking); }}>
                                                    <CancelIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                    Cancel Booking
                                                </MenuItem>
                                            )}
                                        </Menu>
                                    </div>
                                ) : (
                                    <div className="gig-actions">
                                        <Tooltip title={booking.venueAddress ? "Get Directions" : "No address available"}>
                                            <span>
                                                <IconButton 
                                                    className="gig-action-btn" 
                                                    onClick={handleGetDirections}
                                                    disabled={!booking.venueAddress}
                                                    style={!booking.venueAddress ? { opacity: 0.5, pointerEvents: 'none' } : {}}
                                                >
                                                    <DirectionsIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Tooltip title="View Details">
                                            <IconButton 
                                                className="gig-action-btn" 
                                                onClick={handleViewDetails}
                                            >
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Tooltip>
                                        {booking.createdById === currentProfile?.id && (
                                            <Fragment>
                                                <Tooltip title="More Actions">
                                                    <IconButton 
                                                        className="gig-action-btn" 
                                                        onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}
                                                    >
                                                        <span style={{fontSize: '18px', fontWeight: 'bold'}}>...</span>
                                                    </IconButton>
                                                </Tooltip>
                                                {booking.id && (
                                                    <Menu
                                                        open={this.state.actionAnchor[booking.id] != null}
                                                        onClose={() => this.unsetActionAchnor(booking.id)}
                                                        anchorEl={this.state.actionAnchor[booking.id]}
                                                    >
                                                        <MenuItem onClick={() => this.handleOpenDuplicateBookingModal(booking)}>Duplicate Booking</MenuItem>
                                                        {CANCELLABLE_STATUSES.includes(booking.status) && this.isRelatedCreator(booking) && (
                                                            <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.handleOpenCancelBookingModal(booking); }}>
                                                                <CancelIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                                Cancel Booking
                                                            </MenuItem>
                                                        )}
                                                    </Menu>
                                                )}
                                            </Fragment>
                                        )}
                                    </div>
                                );
                                // row.action = (
                                //     <Button
                                //         size="small"
                                //         color="primary"
                                //         className="action-button booking-details"
                                //         component={Link}
                                //         to={
                                //             booking?.type === BookingType.Adhoc.ordinal
                                //                 ? `/privateBooking/${booking.id}/edit`
                                //                 : isEntertainerBookings
                                //                     ? `/booking/${booking.id}/edit`
                                //                     : currentProfile?.type === ProfileType.Musician.ordinal
                                //                         ? `/musician/booking/${booking.id}/details`
                                //                         : currentProfile?.type === ProfileType.Agent.ordinal
                                //                             ? `/booking/${booking.id}/edit`
                                //                             : currentProfile?.type === ProfileType.Staff.ordinal
                                //                                 ? `/booking/${booking.id}/edit`
                                //                                 : ""
                                //         }
                                //     >
                                //         Detail
                                //     </Button>
                                // );

                                row.status = <BookingStatusBadge isPrint={true} status={this.getBookingStatus(booking)}  cancelledBy={ (booking && booking.cancelledBy ? booking.cancelledBy.type : 0)}/>;
                                // row.interested = booking.interested ? booking.interested.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0";
                                // row.going = booking.going ? booking.going.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0";

                                return row;
                            })}
                            // footerRow = {
                            //     currentProfile?.type === ProfileType.Agent.ordinal ? 
                            //         this.renderFooterRow() : undefined
                            // }
                        />
                         <Grid item style={{marginTop: 25}} xs={12} key="more" alignContent="center" alignItems="center" justify="center">
                            <Grid container direction="row" justify="center" alignItems="center">
                                {this.props.bookingRequestStore.showMoreAll ? (
                                    <Button variant="outlined" size="large" color="primary" onClick={this.handleShowMore}>
                                        Show More
                                    </Button>
                                ) : null}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Snackbar
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    open={this.state.acknowledgeSnackbarState}
                    onClose={this.closeAcknowledgeSnackbar}
                    autoHideDuration={5000}
                    message={
                        <span id="message-id">{`${
                            this.state.booking ? this.props.bookingRequestStore.getBookingTitle(this.state.booking) : "Selected gigs"
                        } has been acknowledged.`}</span>
                    }
                    action={[
                        <Button color="primary" size="small" onClick={this.handleUndoAcknowledge}>
                            UNDO
                        </Button>,
                        <IconButton onClick={this.closeAcknowledgeSnackbar} color="primary">
                            <ClearIcon />
                        </IconButton>
                    ]}
                />
                {FACEBOOK_ENABLED && <FacebookPostDialog profileType="venue" callback={this.openAcknowledgeSnackbar} />}

                {FACEBOOK_ENABLED && <FacebookSharePostDialog profileType="musician" reloadData={this.updatedSharedBookingState} />}

                <PrintModal 
                    open = { showPrintOption }
                    closeHandler = { this.closePrintOptionModal }
                    bookings = { selectedBookings }
                />

                <BulkEditModal
                    open={bulkEditModalOpen}
                    onClose={this.closeBulkEditModal}
                    selectedBookings={selectedBookings.map(row => this.props.bookingRequestStore.allGigs.find(b => b.id === row.id)).filter(b => b && this.isRelatedCreator(b) && b.status !== BookingStatusType.Cancelled.ordinal && b.status !== BookingStatusType.CancelledByAct.ordinal && b.status !== BookingStatusType.CancelledByActHistory.ordinal)}
                    onSubmit={this.handleBulkEditSubmit}
                />

                <BulkCancelModal
                    open={bulkCancelModalOpen}
                    onClose={this.closeBulkCancelModal}
                    selectedBookings={selectedBookings.map(row => this.props.bookingRequestStore.allGigs.find(b => b.id === row.id)).filter(b => b && this.isRelatedCreator(b) && b.status !== BookingStatusType.Cancelled.ordinal && b.status !== BookingStatusType.Completed.ordinal)}
                    onComplete={this.handleBulkCancelComplete}
                />
                <ConfirmationModal
                    open={this.state.cancelModalState}
                    title={"Cancel confirmation."}
                    message={`This cannot be undone.  Would you like to cancel this booking?`}
                    closeHandler={this.handleCloseCancelBookingModal}
                    confirmationHandler={this.handleCancelBooking}
                    declineHandler={this.handleCloseCancelBookingModal}
                    confirmationLabel="Cancel"
                />
            </Fragment>
        );
    }
}

export default BookingAll;
